import React from 'react'
import { PieAmchartSeeker } from '@ui-seeker/core'
import { Paper } from '@mui/material'
import { AppResultsSkeleton } from '@components'
import { userData } from '@signals'
import { isDateRangeLoading } from 'Pages/Main/Home/@signals'
import { useSearchAnalyticsDateRangeInfo } from 'Pages/Main/Home/@hooks'


export default function SearchAnalyticsHomePieChart() {

	const { data } = useSearchAnalyticsDateRangeInfo()
	const { percentageSite, siteSeries } = data

	if (isDateRangeLoading.value)
		return <AppResultsSkeleton chart height="calc(26vw - 82px)"/>

	if (userData.value?.newUserLogin) {
		return <Paper sx={{ width: "100%", height: 435 }}/>
	}

	return <PieAmchartSeeker
		rootID="SearchAnalyticsPieChart"
		data={percentageSite}
		title="Percentage of searches per site"
		series={[{
			yField: 'site',
			xField: "percentage",
			innerRadius: 60,
		}]}
		sx={{ height: '21vw' }}
		chartProps={{
			// Legend under the donut: each gets its own space, so the donut never runs out of
			// width when the side menu opens or the screen is narrow
			root: {
				colors: siteSeries?.map(({ color }) => color)
			},
			legend: {
				verticalLayout: false,
				labels: {
					width: 130,
					maxWidth: 130,
					oversizedBehavior: "truncate",
				},
				valueLabels: {
					width: 60,
					textAlign: "right"
				}
			},
			enabledPDF: false
		}}

	/>
}